/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * POST /media_list/prtimes_media_lists/{media_list_id} body
 * @export
 * @interface PostPrtimesMediaListBody
 */
export interface PostPrtimesMediaListBody {
    /**
     * メディアリスト名
     * @type {string}
     * @memberof PostPrtimesMediaListBody
     */
    mediaListName?: string;
    /**
     * プレスリリース配信元のメール送信者名（（表示しません）とかある）
     * @type {string}
     * @memberof PostPrtimesMediaListBody
     */
    senderName?: string;
}

/**
 * Check if a given object implements the PostPrtimesMediaListBody interface.
 */
export function instanceOfPostPrtimesMediaListBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostPrtimesMediaListBodyFromJSON(json: any): PostPrtimesMediaListBody {
    return PostPrtimesMediaListBodyFromJSONTyped(json, false);
}

export function PostPrtimesMediaListBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPrtimesMediaListBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListName': !exists(json, 'media_list_name') ? undefined : json['media_list_name'],
        'senderName': !exists(json, 'sender_name') ? undefined : json['sender_name'],
    };
}

export function PostPrtimesMediaListBodyToJSON(value?: PostPrtimesMediaListBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_name': value.mediaListName,
        'sender_name': value.senderName,
    };
}

